
/**
 *
 * @param {{
 *   boxContentBg,
 *   boxContentBorder,
 *   boxContentBorderColor,
 *   boxContentClassNames,
 *   boxContentTextColor,
 *   boxContentRounded,
 *   boxContentPadding,
 *   boxClassNames,
 *   headerBg,
 *   headerBord,
 *   headerBorderColor,
 *   headerClassNames,
 *   headerContent,
 *   headerPadding,
 *   headerRounded,
 *   headerTextColor
 *   }} useBoxProps
 * @param {boolean|null} sticky
 *
 * @returns {{contentBoxClassNames: string, headerBoxClassNames: string}}
 */
export const useBox = (useBoxProps, sticky = false) => {
  const classParts = ['Bg', 'Border', 'BorderColor', 'TextColor', 'Rounded', 'Padding', 'ClassNames'];
  const classPartsPatterns = ['bg-{{value}}', 'border', 'border-{{value}}', 'text-{{value}}', 'rounded-{{value}}', '{{value}}', '{{value}}'];

  const handleClassnames = (boxPart) => {
    const classNames = classParts.map((part, i) => {
      if (useBoxProps[`${boxPart}${part}`] === undefined) {
        if (`${boxPart}${part}` === 'boxContentBg') {
          useBoxProps[`${boxPart}${part}`] = 'grey-light';
        }

        if (`${boxPart}${part}` === 'boxContentPadding') {
          useBoxProps[`${boxPart}${part}`] = 'p-0';
        }
      }

      return useBoxProps[`${boxPart}${part}`] && classPartsPatterns[i]
          && classPartsPatterns[i].replace('{{value}}', useBoxProps[`${boxPart}${part}`]);
    });

    return classNames
      .filter((classname) => ![undefined, '', null].includes(classname))
      .join(' ')
      .trim();
  }

  return {
    headerBoxClassNames: `${handleClassnames('header')}${sticky && ' sticky-top' || ''}`,
    contentBoxClassNames: handleClassnames('boxContent'),
  }
}
